/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const userProfile = {
  updateEmailForm: {
    newEmailAddress: {
      label: 'Novo endereço de e-mail',
      placeholder: 'Digite ou envie um e-mail',
    },
    confirmNewEmailAddress: {
      label: 'Confirme o novo endereço de e-mail',
      placeholder: 'Digite ou envie um e-mail',
    },
    enterValidEmail: 'Insira um e-mail válido.',
    bothEmailMustMatch: 'Ambos os e-mails devem corresponder',
    password: {
      label: 'Senha',
      placeholder: 'Digite a senha',
    },
    pleaseInputPassword: 'Por favor, digite a senha',
    emailUpdateSuccess: 'Êxito. Por favor, faça login com {{ newUid }}',
  },
  register: {
    confirmPassword: {
      action: 'Confirme a senha',
      label: 'Confirme a senha',
      placeholder: 'Confirm Senha',
    },
    managementInMyAccount: 'Gestão em Minha Conta.',
    termsAndConditions: 'Termos e Condições',
    signIn: 'Eu já tenho uma conta. Tora',
    register: 'Inscrição',
    confirmNewPassword: 'Confirm New Senha',
    resetPassword: 'Redefinir senha',
    createAccount: 'Criar uma conta',
    title: 'Título',
    firstName: {
      label: 'Nome',
      placeholder: 'Nome',
    },
    lastName: {
      label: 'Sobrenome',
      placeholder: 'Sobrenome',
    },
    emailAddress: {
      label: 'Endereço eletrônico',
      placeholder: 'Endereço eletrônico',
    },
    password: {
      label: 'Senha',
      placeholder: 'Senha',
    },
    newPassword: 'Nova Senha',
    emailMarketing:
      'Usar meus dados pessoais para receber boletins informativos por e-mail para campanhas de marketing. Para alterar suas configurações, acesse Consent Gestão em Minha Conta.',
    confirmThatRead: 'Confirmo que li e concordo com o',
    selectTitle: 'Selecione o título',
    passwordMinRequirements:
      'A senha deve ter no mínimo seis caracteres, com letra maiúscula, número e símbolo',
    bothPasswordMustMatch: 'Ambas as senhas devem corresponder',
    titleRequired: 'Título obrigatório.',
    postInscriçãoMessage: 'Faça login com as credenciais fornecidas.',
  },
  forgottenPassword: {
    resetPassword: 'Redefinir senha',
    enterEmailAddressAssociatedWithYourAccount:
      'Digite o endereço de e-mail associado à sua conta',
    emailAddress: {
      label: 'Endereço eletrônico',
      placeholder: 'Digite ou envie um e-mail',
    },
    enterValidEmail: 'Insira um e-mail válido.',
    passwordResetEmailSent:
      'Um e-mail foi enviado a você com informações sobre como redefinir sua senha.',
    passwordResetSuccess: 'Êxito! Agora você pode fazer login usando sua nova senha.',
  },
};
